
  import { api, fetchOnlineConfig } from "@/utils/request";

  export default {
    name: 'LiveEvents',
    data() {
      return {
        loading: false,
        breadcrumb: [
          {
            text: "Home",
            to: "/",
          },
          {
            text: "Event",
            active: true,
          },
        ],
        currentLiveEvent: null,
        upcomingLiveEvent: null,
        isPopularListReady: false,
        otherPopularList: [],
        popularList: [],
        liveData: [],
        title: 'Popular Event',
        mediaType: 'LIVE',
        pagination: {
          currentPage: 1,
          perPage: 9,
        },
        isLiveEventReady: false,
        redirectPage: 'live-events-slug',
        search: this.$route.query.search || '',
        emptyEventPoster: '',
        isEmptyPage: false,
      }
    },
    methods: {
      handleSelectedCategory(category) {
        this.search = ''
        this.fetchMediaList('', category)
      },
      getFilterData() {
        setTimeout(() => {
          this.popularList=[
            {
              mediaTitle: "Trending",
              isActive: true,
            },
            {
              mediaTitle: "Lorem Ipsum Dolor Sit Amet",
              isActive: false,
            },
            {
              mediaTitle: "Lorem Ipsum Dolor Sit Amet",
              isActive: false,
            },
            {
              mediaTitle: "Lorem Ipsum Dolor Sit Amet",
              isActive: false,
            },
          ],
          this.otherPopularList = [
            {
              mediaTitle: "Archive",
              isActive: false,
            },
          ];
          this.isPopularListReady = true;
        }, 3000);
      },
      changePaging(page) {
        this.pagination = {
          ...this.pagination,
          currentPage: page,
        }

        this.fetchMediaList()
      },
      searchMedia(input) {
        this.search = input
        this.fetchMediaList(input)
      },
      onInitCarousel () {
        this.isCarouselReady = true;
      },
      async fetchCurrentLiveEvents() {
        try {
          const resLiveEvent = await api('live-current')

          if (resLiveEvent && resLiveEvent.result) {
            const { result } = resLiveEvent;
            this.currentLiveEvent = result
            this.fetchUpcomingLiveEvents()
          }
        } catch (e) {
          this.fetchUpcomingLiveEvents()
        }
      },
      async fetchUpcomingLiveEvents() {
        try {
          const resLiveEvent = await api('live-upcoming')

          if (resLiveEvent && resLiveEvent.result) {
            const { result } = resLiveEvent;

            this.upcomingLiveEvent = result
          }
          this.isLiveEventReady = true
        } catch (e) {
          this.isLiveEventReady = true
        }
      },
      async fetchMediaList(search= '', category= '') {
        this.liveData = [];
        this.isEmptyPage = false;
        try {
          const reqParams = {
            page: this.pagination.currentPage || 1,
            perPage: this.pagination.perPage,
            mediaType: this.mediaType,
          }

          if (category) reqParams.category = category;
          if (search) reqParams.search = search;

          const medias = await api('medias', reqParams)

          if (medias && medias.result) {
            const result = medias.result;

            const pagination = this.pagination;
            pagination.currentPage = result.currentPage;
            pagination.totalPages = result.totalPages;
            pagination.rows = result.totalPages * this.pagination.perPage;

            this.pagination = pagination;
            this.liveData = result.medias;
            this.isEmptyPage = !result.medias.length;
          }
        } catch (e) {
          this.pagination = {
            ...this.pagination,
            currentPage: 1,
            totalPages: 1,
          };
          this.liveData = [];
          this.isEmptyPage = true;
        }
      },
      async fetchEmptyEventPoster() {
        try {
          const eventPoster = await fetchOnlineConfig('empty-event-poster')
          if (eventPoster && eventPoster.poster) {
            this.emptyEventPoster = eventPoster.poster
            this.isLiveEventReady = true
          }
        } catch (e) {
          this.emptyEventPoster = 'https://a.m.dana.id/resource/imgs/dana-academy/live-event-poster.svg'
          console.warn(e)
          this.isLiveEventReady = true
        }
      },
    },
    async created() {
      this.getFilterData()
      if (this.search) {
        this.fetchMediaList(this.search);
      } else {
        this.fetchMediaList();
      }
      this.fetchCurrentLiveEvents();
      this.fetchEmptyEventPoster();
    },
  }
